import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';

@Component({
  selector: 'app-popup-validacao',
  standalone: true,
  imports: [NgIf, NgFor],
  templateUrl: './popup-validacao.component.html',
  styleUrl: './popup-validacao.component.scss'
})
export class PopupValidacaoComponent {
  @Input() visivel: boolean = false;
  @Input() permitirContinuar: boolean = true;
  @Input() mensagensInconsistencia: string[] = [];

  @Output() fechar = new EventEmitter<void>();
  @Output() continuarMesmoAssim = new EventEmitter<void>();
  @Output() corrigirErros = new EventEmitter<void>();

  constructor() {}

  // Métodos para os eventos
  fecharPopup(): void {
    this.fechar.emit();
  }

  continuarNavegacao(): void {
    this.continuarMesmoAssim.emit();
  }

  corrigirInconsistencias(): void {
    this.corrigirErros.emit();
  }

  // Para fechar clicando fora do modal (verificar necessidade)
  fecharSeClicarFora(event: Event): void {
    if (event.target === event.currentTarget) {
      this.fecharPopup();
    }
  }
}